import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "PageErrorDetails" }
const _hoisted_2 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.navigateToOverviewPage && _ctx.navigateToOverviewPage(...args)))
    }, " Back to overview "),
    (_ctx.selectedImport)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("h2", null, "Details of import with id: " + _toDisplayString(_ctx.selectedImport.id), 1 /* TEXT */),
          _createElementVNode("ul", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedImport.messages, (message) => {
              return (_openBlock(), _createElementBlock("li", null, _toDisplayString(message), 1 /* TEXT */))
            }), 256 /* UNKEYED_FRAGMENT */))
          ])
        ], 64 /* STABLE_FRAGMENT */))
      : (_openBlock(), _createElementBlock("h2", _hoisted_2, "No import selected"))
  ]))
}